import { render, staticRenderFns } from "./BasicInfo.pug?vue&type=template&id=5cf0e714&scoped=true&lang=pug&"
import script from "./BasicInfo.vue?vue&type=script&lang=js&"
export * from "./BasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfo.scss?vue&type=style&index=0&id=5cf0e714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf0e714",
  null
  
)

export default component.exports